import { Select } from 'antd';
import React, { FC, useMemo } from 'react';
import { languages } from 'core/intl/languages';
import { useMutation, useQueryCache } from 'react-query';
import { UsersAPI } from 'api/UsersAPI';
import { QueryKey } from 'api/queryKey';
import { getLanguageCode } from 'core/intl/intlUtils';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import {
  isAuthenticatedSelector,
  needMfaVerificationSelector,
} from 'state/auth/auth.selectors';
import { AppIntlContext } from 'core/intl/AppIntlProvider';

const { Option } = Select;

export const LanguageControl: FC = () => {
  const { handleLocalLanguageChange } = React.useContext(AppIntlContext);

  const [mutate] = useMutation(UsersAPI.setUserLanguage);
  const queryCache = useQueryCache();
  const intl = useIntl();
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const needMfaVerification = useSelector(needMfaVerificationSelector);

  const handleChange = (value: string) => {
    if (!needMfaVerification && isAuthenticated) {
      mutate(value, {
        onSuccess: () => {
          queryCache.invalidateQueries(QueryKey.UserSettings);
        },
      });
    } else {
      handleLocalLanguageChange && handleLocalLanguageChange(value);
    }
  };

  const languagesOptions = useMemo(() => {
    return languages
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((a) => (
        <Option key={a.code} value={a.code}>
          {a.name.toUpperCase()}
        </Option>
      ));
  }, []);

  return (
    <Select
      value={getLanguageCode(intl.locale)}
      style={{ width: 70, marginRight: '1rem' }}
      onChange={handleChange}
    >
      {languagesOptions}
    </Select>
  );
};
